import { StaticImageData } from 'next/image';

import { useTheme } from '@/hooks/useTheme';

import Trust1 from '../../../../assets/homeImages/Trusted1.png';
import Trust2 from '../../../../assets/homeImages/Trusted2.png';
import Trust3 from '../../../../assets/homeImages/Trusted3.png';
import Trust4 from '../../../../assets/homeImages/Trusted4.png';
import Trust5 from '../../../../assets/homeImages/Trusted5.png';

type TrustedDataType = {
  id: number;
  image: StaticImageData;
  name: string;
};

const worksData: TrustedDataType[] = [
  {
    id: 1,
    image: Trust1,
    name: '_ShaniceBest',
  },
  {
    id: 2,
    image: Trust2,
    name: '0x1Oreo',
  },
  {
    id: 3,
    image: Trust3,
    name: 'gabusch',
  },
  {
    id: 4,
    image: Trust4,
    name: 'renacassinelli',
  },
  {
    id: 5,
    image: Trust5,
    name: '0xbrov',
  },
];

const TrustedSection: React.FC = () => {
  const { mode } = useTheme();

  return (
    <section className='px-[25px] mb-28'>
      <div className='flex flex-col items-center mt-16 lg:mt-10 gap-20'>
        <h2 className='text-center text-[28px]/9 lg:text-[40px]/[60px] font-semibold !text-transparent dark:!text-transparent bg-clip-text bg-[radial-gradient(52%_111.11%_at_50%_50%,_#000_82.64%,#17161699_100%)] dark:bg-[radial-gradient(50%_111.11%_at_50%_50%,#FFF_82.64%,#ffffff99_100%)]'>Trusted By</h2>
        <div className='flex flex-wrap justify-center gap-5'>
          {worksData.map((item) => (
            <div key={item.id} className='flex flex-col items-center px-6 py-8 rounded-lg dark:bg-grey-coal w-[207px] h-[207px]'>
              <img src={item.image.src} alt={item.name} className='w-[115px] h-[115px]' />
              <p className='text-center text-xl font-medium text-primary-grey-400 dark:text-white-dark mt-4'>{item.name}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustedSection;
